import React, {ReactNode} from 'react'
import {Spin} from 'antd'

import {LoadingOutlined} from '@ant-design/icons'
import clsx from 'clsx'

type Props = {
  props?: any
  spinning?: boolean | null
  hideLoadingText?: boolean | false
  loadingText?: string
  className?: string
  size?: number
  position?: 'default' | 'inline'
  children: ReactNode
}

const MarvelSpin: React.FC<Props> = (props) => {
  const {hideLoadingText = false, loadingText = 'Loading...', spinning, className = '', size = 50, position = 'default', children} = props

  const loadingIcon = <LoadingOutlined style={{fontSize: size}} className='mt-n20' spin />

  if (position === 'default') {
    return (
      <Spin className={clsx(className)} tip={hideLoadingText ? null : <p className='mb-0 fw-bold fs-4 me-n7'>{loadingText}</p>} spinning={spinning ?? false} indicator={loadingIcon}>
        {children}
      </Spin>
    )
  } else {
    return (
      <div className='d-flex justify-content-center align-items-center'>
        <LoadingOutlined className='me-2 text-primary' style={{fontSize: size}} spin />
        <p className='mb-0 fw-bold text-primary' style={{letterSpacing: -0.75}}>
          Loading...
        </p>
      </div>
    )
  }
}

export {MarvelSpin}
